import { Link, useLocation } from 'react-router-dom';
import { ClipboardList } from 'lucide-react';
import { useSolicitation } from '../context/SolicitationContext';

export default function MobileRequestBar() {
  const { count } = useSolicitation();
  const { pathname } = useLocation();
  if (count === 0 || pathname.startsWith('/solicitacao') || pathname.startsWith('/finalizar') || pathname.startsWith('/admin')) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 md:hidden" data-testid="mobile-request-bar">
      <Link
        to="/solicitacao"
        className="flex items-center justify-between rounded-full bg-navy px-5 py-3.5 text-white shadow-lg shadow-navy/30"
        data-testid="mobile-request-bar-button"
      >
        <span className="flex items-center gap-2 text-sm font-semibold">
          <ClipboardList className="h-5 w-5" /> Minha Solicitação
        </span>
        <span className="rounded-full bg-white px-2.5 py-0.5 text-xs font-bold text-navy" data-testid="mobile-request-bar-count">
          {count} {count === 1 ? 'item' : 'itens'}
        </span>
      </Link>
    </div>
  );
}
